'use strict'

import angular from 'angular'
import AddController from './add.controller'

export default angular.module('updateServerApp.keyboard.add', [])
  .controller('KeyboardAddController', AddController)
  .name



// WEBPACK FOOTER //
// ./client/app/keyboard/add/index.js